<template>
    <main class="landing-container">
        <h2>{{ platformName }}</h2>
        <h1>Your feed, your way.</h1>
        <a href="#" class="google-btn" @click="handleClick">
            <img src="../assets/google_logo.png" alt="Google logo" class="google-logo" />
            Sign in with Google
        </a>
        <section class="panes">
            <section class="pane">
                Engage in Thoughtful Conversations
                <section class="pane-sub-content">
                    Powered by LLMs and guided by community moderation to help identify and minimize logical fallacies
                    and misinformation
                </section>
            </section>
            <section class="pane">
                Personalize Your Recommendations
                <section class="pane-sub-content">
                    Converse directly with your recommendation engine for more transparent, customized results
                </section>
                <section class="pane-sub-content">
                    Tell it exactly what you want, like:
                    <br>
                    <em>"Show me content I might disagree with"</em>
                    <em>"More Ancient Greek philosophy, please!"</em>
                </section>
            </section>
            <section class="pane">
                Connect locally
                <section class="pane-sub-content">
                    Discover, create, and join meetups tailored to your interests and location
                </section>
            </section>
        </section>
    </main>
</template>

<script>
import { getPlatformName, getBackendURL, local} from '@/util.js';
export default {
    name: 'SignIn',
    data() {
        const baseURL = getBackendURL();
        return {
            platformName: getPlatformName(),
            urls: {
                googleSignIn: `${baseURL}/v1/signin/google/signin`
            }
        };
    },
    methods: {
        handleClick() {
            if(local){
                this.$router.push("/signup")
                return
            }
            window.location.href = this.urls.googleSignIn
        }
    },
    mounted() {
        const img = new Image();
        img.src = require('@/assets/landing_bg.jpg');
        img.onload = () => {
            document.querySelector('.landing-container').style.backgroundImage = `url('${img.src}')`;
        };
    }
}
</script>

<style lang="scss" scoped>
$product-font-color: #f8f9fa;
$brand-font: "Playfair Display", serif;
$body-font: "Inter", sans-serif;


.landing-container {
    /* --- layout --- */
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 1rem;
    margin: 0;
    position: relative;
    width: 100%;
    box-sizing: border-box;

    /* --- theme --- */
    font-family: $body-font;
    color: $product-font-color;
    background: url('../assets/landing_small.jpg') center/cover no-repeat;
    background-color: #0a0f1a; // fallback dark color
    transition: background-image 0.5s ease-in-out;

    h2 {
        /* --- layout --- */
        margin-bottom: 2rem;

        /* --- theme --- */
        font-family: $brand-font;
        font-size: 1.2rem;
        font-weight: 100;

        @media (max-width: 768px) {
            font-size: 1rem;
        }
    }

    h1 {
        /* --- layout --- */
        margin-bottom: 4rem;

        /* --- theme --- */
        font-family: $brand-font;
        font-size: 4rem;

        @media (max-width: 768px) {
            font-size: 3rem;
        }
    }

    .google-btn {
        /* --- layout --- */
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 0.75rem 1.5rem;
        border-radius: 9px;
        text-decoration: none;

        /* --- theme --- */
        font-size: 0.8rem;
        font-weight: 550;
        background-color: $product-font-color;
        color: black;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        transition: background-color 0.2s ease;

        .google-logo {
            /* --- layout --- */
            width: 20px;
            height: 20px;
            margin-right: 0.5rem;
        }
    }

    .google-btn:hover {
        /* --- theme --- */
        background-color: #eee;
    }

    .panes {
        /* --- layout --- */
        display: flex;
        flex-direction: row;
        gap: 4rem;
        margin-top: 4rem;
        align-items: center;

        @media (max-width: 768px) {
            flex-direction: column;
        }

        .pane {
            /* --- layout --- */
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 1.2rem;
            flex-direction: column;
            flex: 1;
            border-radius: 1.5rem;

            /* --- theme --- */
            font-size: 1.5rem;
            font-weight: 550;
            background-color: rgba(255, 255, 255, 0.85);
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
            color: rgba(0, 0, 0, 0.95);


            @media (max-width: 768px) {
                width: 80%;
            }

            .pane-sub-content {
                /* --- layout --- */
                padding: 1.2rem;
                flex-direction: column;
                border-radius: 1rem;
                margin-top: 1rem;
                display: flex;

                /* --- theme --- */
                font-size: 0.9rem;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.95);
            }
        }
    }
}
</style>
